import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import { FaArrowUpFromGroundWater, FaArrowUpFromWaterPump, FaTemperatureHalf, FaTemperatureHigh } from "react-icons/fa6";
import { BsSpeedometer } from "react-icons/bs";
import { IoIosSpeedometer } from "react-icons/io";
import { RiShipLine, RiShipFill } from "react-icons/ri";
import { Badge, Input, Modal, Popover, Table, Tooltip, Button, message } from 'antd';
import Speedo from '../../components/Sensor/Speedo';
import Temperatur from '../../components/Sensor/Temperatur';
import WaterLevel from '../../components/Sensor/WaterLevel';
import WaterMeterChart from '../../components/Sensor/WaterMeter';
import ShipStabilization from '../Sensor/Inclino/ShipStabilization';
import { IoSettings, IoSettingsOutline } from 'react-icons/io5';
import { UpdateIOT_M_Sensor } from '../../Api/UpdateData';
import Swal from 'sweetalert2';

const TableMonitoring = ({ dataSource, isLoading, loadingRows, updateData }) => {

    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState([]);
    const [loadingData, setLoadingData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = (dataSource || []).map((item, index) => {
                    const sensors = (item.current || []).reduce((acc, sensor) => {
                        acc[sensor.SensorCode] = sensor;
                        return acc;
                    }, {});

                    const getSensor = (code) => sensors[code] || {};

                    const lastSensor = item.current?.[item.current.length - 1] || {};

                    return {
                        ...item,
                        key: index + 1,
                        RefDate: lastSensor.RefDate || "",
                        name: item.ShipName,
                        status: lastSensor.Status || 0,

                        tmp1: getSensor("TMP01").Value1 || 0,
                        tmp2: getSensor("TMP02").Value1 || 0,
                        rpm1: getSensor("RPM01").Value1 || 0,
                        rpm2: getSensor("RPM02").Value1 || 0,
                        level1: getSensor("LVL01").Value1 || 0,
                        level2: getSensor("LVL02").Value1 || 0, // sesuaikan kalau memang ada LVL02
                        inc1: getSensor("INC01").Value1 || 0,
                        inc2: getSensor("INC01").Value2 || 0,
                    };
                });

                setData(response);
                // console.log(response);

                // Buat data loading placeholder
                if (loadingRows && Object.keys(loadingRows).length > 0) {
                    const loadingItems = Object.keys(loadingRows).map((shipCode, index) => ({
                        key: `loading-${shipCode}`,
                        ShipCode: shipCode,
                        ShipName: shipCode,
                        name: shipCode,
                        isLoading: true
                    }));
                    setLoadingData(loadingItems);
                } else {
                    setLoadingData([]);
                }
            } catch (error) {
                console.log('error', error);

            }
        }

        fetchData();

    }, [dataSource, loadingRows]);

    const handleLink = (record) => {
        navigate(`/dashboard?KodeCabang=${record.KodeCabang}&ShipCode=${record.ShipCode}`)
        const payload = {
            KodeCabang: record.KodeCabang,
            NamaCabang: record.NamaCabang,
            ShipCode: record.ShipCode,
            ShipName: record.ShipName,
        }
        localStorage.setItem('Filter', JSON.stringify(payload));
    }

    const [dataSetting, setDataSetting] = useState(null);
    const [editedSensors, setEditedSensors] = useState({});

    const handleSettings = (record) => {
        setDataSetting(record);
        // Initialize edited sensors with current max values
        const initialEdited = {};
        record.current?.forEach((sensor) => {
            initialEdited[sensor.SensorCode] = {
                MaxValue1: sensor.MaxValue1 || 0,
                MaxValue2: sensor.MaxValue2 || 0,
                MaxValue3: sensor.MaxValue3 || 0,
            };
        });
        setEditedSensors(initialEdited);
        setIsModalOpen(true);
    }

    const handleMaxValueChange = (sensor, field, value) => {
        // console.log(sensor);
        setEditedSensors(prev => ({
            ...prev,
            [sensor.SensorCode]: {
                ...prev[sensor.SensorCode],
                [field]: value === '' ? 0 : parseFloat(value) || 0
            }
        }));
    }

    const handleSaveSensorSettings = async () => {
        try {
            const params = {
                AccountId: dataSetting.KodeCabang,
                ObjectCode: dataSetting.ShipCode,
            }
            const payload = dataSetting.current.map((sensor, index) => ({
                AccountId: dataSetting.KodeCabang,
                ObjectCode: dataSetting.ShipCode,
                SensorId: sensor.SensorCode,
                MaxValue1: editedSensors[sensor.SensorCode]?.MaxValue1 || sensor.MaxValue1,
                MaxValue2: editedSensors[sensor.SensorCode]?.MaxValue2 || sensor.MaxValue2,
                MaxValue3: editedSensors[sensor.SensorCode]?.MaxValue3 || sensor.MaxValue3,
            }));
            // console.log('payload', payload);
            const response = await UpdateIOT_M_Sensor(params, payload);
            if (response.status === 200) {
                // console.log('response', response);
                Swal.fire({
                    icon: 'success',
                    title: 'Success !',
                    text: response.data.message,
                    confirmButtonText: 'OK',
                }).then(() => {
                    setIsModalOpen(false);
                    updateData(true);
                });
            }
        } catch (error) {
            console.log('error', error);
            message.error('Failed to update !');
        }
    }

    const columns = [
        {
            title: 'VESSEL',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            render: (value, record) => {
                if (record.isLoading) {
                    return (
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                            <span className="text-gray-400">{value}</span>
                        </div>
                    );
                }
                return (
                    <button onClick={() => handleLink(record)}>
                        <p className="font-bold text-blue-700 hover:text-black transition-all duration-300">{value}</p>
                    </button>
                )
            },
        },
        {
            title: 'STATUS',
            dataIndex: 'status',
            key: 'status',
            render: (value, record) => {
                if (record.isLoading) {
                    return <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>;
                }
                return (
                    <>
                        <Popover
                            className="cursor-pointer"
                            content={
                                <>
                                    <p className="font-medium">Last Update: {record.RefDate}</p>
                                </>
                            }
                        // arrow={false}
                        // placement="bottomLeft"
                        >
                            <Badge status={value ? 'success' : 'error'} text={value ? 'Online' : 'Offline'} className="hover:text-blue-600 transition-all duration-300 cursor-pointer" />
                        </Popover>
                    </>
                )
            }
        },
        {
            title: <BsSpeedometer size={18} />,
            dataIndex: 'rpm1',
            key: 'rpm1',
            render: (value, record) => {
                if (record.isLoading) {
                    return <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>;
                }
                return (
                    <>
                        <Popover
                            content={
                                <div className="flex flex-col justify-center lg:w-[600px]">
                                    <div className="flex justify-between mb-2">
                                        <h1 className="text-xl font-bold text-center">{record.ShipName} (RPM)</h1>
                                        <p className="text-gray-500 text-lg font-medium">{record.RefDate}</p>
                                    </div>
                                    <div className="flex">
                                        <Speedo dataSource={record.current} DisplayNo={3} />
                                        <Speedo dataSource={record.current} DisplayNo={5} />
                                    </div>
                                </div>
                            }
                            arrow={false}
                            placement="bottomLeft"
                        >
                            <IoIosSpeedometer
                                size={18}
                                className="font-bold hover:text-blue-600 transition-all duration-300 cursor-pointer"
                            />
                        </Popover>
                    </>
                )
            }
        },
        {
            title: <FaTemperatureHigh size={18} />,
            dataIndex: 'tmp1',
            key: 'tmp1',
            render: (value, record) => {
                if (record.isLoading) {
                    return <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>;
                }

                const [TMP01] = record.current.filter((item) => item.DisplayNo === 2);
                const [TMP02] = record.current.filter((item) => item.DisplayNo === 4);

                return (
                    <>
                        <Popover
                            content={
                                <div className="flex flex-col justify-center lg:w-[600px]">
                                    <div className="flex justify-between mb-2">
                                        <h1 className="text-xl font-bold text-center">{record.ShipName} (TEMPERATUR)</h1>
                                        <p className="text-gray-500 text-lg font-medium">{record.RefDate}</p>
                                    </div>
                                    <div className="flex">
                                        <Temperatur dataSource={TMP01} />
                                        <Temperatur dataSource={TMP02} />
                                    </div>
                                </div>
                            }
                            arrow={false}
                            placement="bottomLeft"
                        >
                            <FaTemperatureHalf
                                size={18}
                                className="text-[#83CA16] font-bold hover:text-blue-600 transition-all duration-300 cursor-pointer"
                            />
                        </Popover>
                    </>
                )
            }
        },
        {
            title: <FaArrowUpFromWaterPump size={18} />,
            dataIndex: 'level1',
            key: 'level1',
            render: (_, record) => {
                if (record.isLoading) {
                    return <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>;
                }
                const [level] = record.current?.filter((currentItem) =>
                    currentItem?.SensorCode?.startsWith("LVL"));
                return (
                    <>
                        <Popover
                            content={
                                <div className="flex flex-col justify-center lg:w-[600px]">
                                    <div className="flex justify-between mb-2">
                                        <h1 className="text-xl font-bold text-center">{record.ShipName} (LEVEL)</h1>
                                        <p className="text-gray-500 text-lg font-medium">{record.RefDate}</p>
                                    </div>
                                    <div className="flex">
                                        <WaterLevel dataSource={level} />
                                        <WaterMeterChart dataSource={level} />
                                    </div>
                                </div>
                            }
                            arrow={false}
                            placement="bottomLeft"
                        >
                            <FaArrowUpFromGroundWater
                                size={18}
                                className="text-[#00A1D1] font-bold hover:text-blue-600 transition-all duration-300 cursor-pointer"
                            />
                        </Popover>
                    </>
                )
            }
        },
        {
            title: <RiShipFill size={18} />,
            dataIndex: 'inc1',
            key: 'inc1',
            render: (value, record) => {
                if (record.isLoading) {
                    return <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>;
                }

                const [INC01] = record.current.filter((item) => item.DisplayNo === 7);

                return (
                    <>
                        <Popover
                            content={
                                <div className="flex flex-col justify-center lg:w-[600px]">
                                    <div className="flex justify-between mb-2">
                                        <h1 className="text-xl font-bold text-center">{record.ShipName} (INCLINO)</h1>
                                        <p className="text-gray-500 text-lg font-medium">{record.RefDate}</p>
                                    </div>
                                    <div className="flex">
                                        <ShipStabilization dataSource={INC01} />
                                    </div>
                                </div>
                            }
                            arrow={false}
                            placement="bottomLeft"
                        >
                            <RiShipLine
                                size={18}
                                className="text-gray-600 font-bold hover:text-blue-600 transition-all duration-300 cursor-pointer"
                            />
                        </Popover>
                    </>
                )
            }
        },
        {
            title: <IoSettings size={18} />,
            dataIndex: 'settings',
            key: 'settings',
            render: (value, record) => {
                if (record.isLoading) {
                    return <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>;
                }
                return (
                    <div>
                        {/* <Popover
                            content={
                                <div className="flex flex-col justify-center lg:w-[600px]">
                                    <h1 className="text-xl font-bold text-center">{record.ShipName} (SETTINGS)</h1>
                                </div>
                            }
                            arrow={false}
                            placement="bottomLeft"
                        >
                            <IoSettingsOutline size={18} />
                        </Popover> */}
                        <button onClick={() => handleSettings(record)} className="hover:text-blue-600 transition-all duration-300 cursor-pointer">
                            <IoSettingsOutline size={18} />
                        </button>
                    </div>
                )
            }
        }
    ];

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const combinedData = [...filteredData, ...loadingData];

    return (
        <>
            <div className="flex gap-4 p-4">
                <Input
                    allowClear
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearch}
                    prefix={<SearchOutlined />}
                    className="w-full"
                />
            </div>

            <Table
                dataSource={combinedData}
                columns={columns}
                pagination={false}
                loading={isLoading}
                scroll={{ x: 'max-content' }}
            />

            <Modal
                centered
                title={dataSetting?.ShipName && (
                    <div className="pb-4 border-b">
                        <h2 className="text-lg font-bold text-gray-800">SETTING {dataSetting.ShipName}</h2>
                        <p className="text-sm text-gray-500">Last Update: {dataSetting.RefDate}</p>
                    </div>
                )}
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                width={1200}
                styles={{
                    body: {
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }
                }}
                footer={[
                    <Button key="cancel" onClick={() => setIsModalOpen(false)}>
                        Cancel
                    </Button>,
                    <Button key="save" type="primary" onClick={handleSaveSensorSettings}>
                        Save Setting
                    </Button>,
                ]}
            >
                <div className="flex flex-col gap-4">


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {dataSetting?.current?.map((sensor, index) => (
                            <div key={index} className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
                                {/* Header */}
                                <div className="mb-4 pb-3 border-b">
                                    <p className="font-bold text-gray-800">{sensor.SensorCode}</p>
                                    <p className="text-xs text-gray-500">{sensor.DisplayGroupName}</p>
                                </div>

                                {/* Current Values Display */}
                                {/* <div className="space-y-3 mb-4 pb-4 border-b bg-gray-50 p-3 rounded">
                                    {sensor.Value1 !== 0 || sensor.MaxValue1 !== 0 ? (
                                        <div>
                                            <div className="flex justify-between items-center mb-1">
                                                <span className="text-sm font-medium text-gray-700">Value 1</span>
                                                <span className="text-sm font-bold text-blue-600">
                                                    {sensor.Value1.toFixed(2)} / {sensor.MaxValue1}
                                                </span>
                                            </div>
                                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                                <div
                                                    className={`h-2.5 rounded-full transition-all ${sensor.Value1 > sensor.MaxValue1 * 0.9 ? 'bg-red-500' :
                                                            sensor.Value1 > sensor.MaxValue1 * 0.7 ? 'bg-yellow-500' :
                                                                'bg-green-500'
                                                        }`}
                                                    style={{
                                                        width: `${Math.min((sensor.Value1 / sensor.MaxValue1) * 100, 100)}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {sensor.Value2 !== 0 || sensor.MaxValue2 !== 0 ? (
                                        <div>
                                            <div className="flex justify-between items-center mb-1">
                                                <span className="text-sm font-medium text-gray-700">Value 2</span>
                                                <span className="text-sm font-bold text-blue-600">
                                                    {sensor.Value2.toFixed(2)} / {sensor.MaxValue2}
                                                </span>
                                            </div>
                                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                                <div
                                                    className={`h-2.5 rounded-full transition-all ${sensor.Value2 > sensor.MaxValue2 * 0.9 ? 'bg-red-500' :
                                                            sensor.Value2 > sensor.MaxValue2 * 0.7 ? 'bg-yellow-500' :
                                                                'bg-green-500'
                                                        }`}
                                                    style={{
                                                        width: `${Math.min((sensor.Value2 / sensor.MaxValue2) * 100, 100)}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {sensor.Value3 !== 0 || sensor.MaxValue3 !== 0 ? (
                                        <div>
                                            <div className="flex justify-between items-center mb-1">
                                                <span className="text-sm font-medium text-gray-700">Value 3</span>
                                                <span className="text-sm font-bold text-blue-600">
                                                    {sensor.Value3.toFixed(2)} / {sensor.MaxValue3}
                                                </span>
                                            </div>
                                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                                <div
                                                    className={`h-2.5 rounded-full transition-all ${sensor.Value3 > sensor.MaxValue3 * 0.9 ? 'bg-red-500' :
                                                            sensor.Value3 > sensor.MaxValue3 * 0.7 ? 'bg-yellow-500' :
                                                                'bg-green-500'
                                                        }`}
                                                    style={{
                                                        width: `${Math.min((sensor.Value3 / sensor.MaxValue3) * 100, 100)}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div> */}

                                {/* Input Fields for Max Values */}
                                <div className="space-y-3">
                                    <p className="text-sm font-semibold text-gray-800">Edit Max Values</p>

                                    {sensor.MaxValue1 !== 0 ? (
                                        <div>
                                            <label className="text-xs font-medium text-gray-700 block mb-1">Max Value 1</label>
                                            <Input
                                                type="number"
                                                placeholder="Enter Max Value 1"
                                                value={editedSensors[sensor.SensorCode]?.MaxValue1 || ''}
                                                onChange={(e) => handleMaxValueChange(sensor, 'MaxValue1', e.target.value)}
                                                className="w-full"
                                            />
                                        </div>
                                    ) : null}

                                    {sensor.MaxValue2 !== 0 ? (
                                        <div>
                                            <label className="text-xs font-medium text-gray-700 block mb-1">Max Value 2</label>
                                            <Input
                                                type="number"
                                                placeholder="Enter Max Value 2"
                                                value={editedSensors[sensor.SensorCode]?.MaxValue2 || ''}
                                                onChange={(e) => handleMaxValueChange(sensor, 'MaxValue2', e.target.value)}
                                                className="w-full"
                                            />
                                        </div>
                                    ) : null}

                                    {sensor.MaxValue3 !== 0 ? (
                                        <div>
                                            <label className="text-xs font-medium text-gray-700 block mb-1">Max Value 3</label>
                                            <Input
                                                type="number"
                                                placeholder="Enter Max Value 3"
                                                value={editedSensors[sensor.SensorCode]?.MaxValue3 || ''}
                                                onChange={(e) => handleMaxValueChange(sensor, 'MaxValue3', e.target.value)}
                                                className="w-full"
                                            />
                                        </div>
                                    ) : null}
                                </div>

                                {/* Status */}
                                <div className="mt-3 pt-3 border-t flex items-center justify-between">
                                    <span className="text-xs text-gray-600">Status</span>
                                    <Badge
                                        status={sensor.Status ? 'success' : 'error'}
                                        text={sensor.Status ? 'Active' : 'Inactive'}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default TableMonitoring